import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import Spinner from "../app/components/Spinner";

const AdminProtectedRoute = ({ element }) => {
    const {
        loading,
        isAuthenticated,
        isAdmin,
    } = useAuth();

    if (loading) {
        return <Spinner />;
    }

    if (!isAuthenticated || !isAdmin) {
        return <Navigate to="/admin" replace />;
    }

    return element;
};

export default AdminProtectedRoute;
